<div class="detail-wrap"
     [style.height]="height + 'px'"
     *ngIf="dialect">

  <div class="detail-menu">
    <div class="menu-wrap" #menuWrap>
      <a class="detail-menu-btn bookmark-btn {{ getBmCss(dialect) }}"
         (click)="ToggleBookmark($event, dialect)"></a>
      <a class="detail-menu-btn close-btn"
         (click)="onClose()"></a>
    </div>

  </div>

  <div class="detail-list">

    <div class="detail-box">

      <div class="info-list-box">
        <app-dialect-detail-standard class="row"
                                     [class.long]="classLong"
                                     [dialect]="dialect">
        </app-dialect-detail-standard>


        <ng-container
          *ngFor="let mean of dialect.meaning3; let midx = index">

         <div class="row type-center"
              *ngIf="dialect.GetMeaning3Nth(midx)">

          <div class="subject-box" style="top:2px;">뜻{{ midx > 0 ? midx : '' }}</div>
          <div class="con-box">
            <div class="meaning-list">
              <app-link-content class="meaning-box"
                                [content]="dialect.GetMeaning3Nth(midx) | slash2br | resize"></app-link-content>
            </div>

            <div class="other-list"
                 *ngIf="dialect.GetExample3Nth(midx)">

              <div class="other-box">
                <div class="other-type-box">
                  <div class="other-type">예</div>
                </div>
                <app-link-content class="other-txt"
                                  [content]="dialect.GetExample3Nth(midx) | slash2br | resize"></app-link-content>
              </div>

            </div>

            <div class="other-list"
                 *ngIf="dialect.GetExplanation3Nth(midx)">

              <div class="other-box">
                <div class="other-type-box">
                  <div class="other-type">풀이</div>
                </div>
                <app-link-content class="other-txt"
                                  [content]="dialect.GetExplanation3Nth(midx) | slash2br | resize"></app-link-content>
              </div>

            </div>


          </div>

        </div>
        </ng-container>

        <div class="row type-center"
             *ngIf="wordMoreItems.length > 0 || sameAreaDialects.length > 0">
          <div class="subject-box" style="top:2px;">비슷한 말</div>
          <div class="con-box">
            <div class="meaning-list similar-meaning-list">
              <ng-container *ngFor="let same of sameAreaDialects; let last = last">
                <span class="similar-meaning-box same-area-meaning-box"
                      role="button"
                      tabindex="0"
                      (click)="onClickSameAreaDialect($event, same)"
                      (keydown.enter)="onClickSameAreaDialect($event, same)">
                  {{ same.word }}
                </span>
                <span *ngIf="!last || wordMoreItems.length > 0" class="similar-meaning-box">,&nbsp;</span>
              </ng-container>

              <span *ngFor="let wordMore of wordMoreItems; let last = last"
                    class="similar-meaning-box">
                {{ getWordMoreDisplay(wordMore, last) }}
              </span>
            </div>

          </div>
        </div>

      </div>

      <div class="detail-box" *ngIf="otherAreaDialects.length > 0">

        <div class="other-region-box">
          <div class="head-box">

            <div class="head-txt">다른 지역의 같은 말</div>

            <a class="map-btn" (click)="onOpenMap()">
              <i class="ic ic-map"></i>
              <div class="txt">지도 보기</div>
            </a>
          </div>

          <div class="body-box">
            <div class="other-region-list">

              <app-other-region-dialect *ngFor="let other of otherAreaDialects"
                                        [dialect]="other"
                                        class="other-box">
              </app-other-region-dialect>

            </div>
          </div>

        </div>


      </div>
    </div>

  </div>
